import React from "react";
import {
  JhPagination,
  JhPaginationContent,
  JhPaginationItem,
  JhPaginationLink,
  JhPaginationNext,
  JhPaginationPrevious,
  JhPaginationEllipsis
} from "designPackages/paginationPackage";

const JhPaginationWrapper = ({
  totalCount,
  currentPage,
  setPage,
  itemsPerPage = 20,
  showScrollToTop = true
}) => {
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const handlePageChange = newPage => {
    if (showScrollToTop) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
    setPage(newPage);
  };

  const showPrevious = currentPage > 1;
  const showNext = currentPage < totalPages;

  // Don't render if there's only one page or no pages
  if (totalPages <= 1) {
    return null;
  }

  // Calculate which pages to show
  const getPageNumbers = () => {
    const delta = 1; // Number of pages to show on each side of current page
    const range = [];
    const rangeWithDots = [];

    // Always include first page, last page, and pages around current page
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 || // First page
        i === totalPages || // Last page
        (i >= currentPage - delta && i <= currentPage + delta) // Pages around current
      ) {
        range.push(i);
      }
    }

    // Add ellipsis where there are gaps
    let prev = 0;
    for (const i of range) {
      if (prev && i - prev > 1) {
        rangeWithDots.push("ellipsis");
      }
      rangeWithDots.push(i);
      prev = i;
    }

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers();

  return (
    <JhPagination>
      <JhPaginationContent>
        {showPrevious && (
          <JhPaginationItem>
            <JhPaginationPrevious
              onPrevious={() => handlePageChange(currentPage - 1)}
              className="cursor-pointer bg-muted"
            />
          </JhPaginationItem>
        )}

        {pageNumbers.map((item, index) => {
          if (item === "ellipsis") {
            return (
              <JhPaginationItem key={`ellipsis-${index}`}>
                <JhPaginationEllipsis />
              </JhPaginationItem>
            );
          }

          return (
            <JhPaginationItem key={item}>
              <JhPaginationLink
                isActive={currentPage === item}
                onPageChange={() => handlePageChange(item)}
                className={`cursor-pointer ${currentPage !== item
                  ? "bg-muted cursor-pointer"
                  : "pointer-events-none"
                  }`}
              >
                {item}
              </JhPaginationLink>
            </JhPaginationItem>
          );
        })}

        {showNext && (
          <JhPaginationItem>
            <JhPaginationNext
              onNext={() => handlePageChange(currentPage + 1)}
              className="cursor-pointer bg-muted"
            />
          </JhPaginationItem>
        )}
      </JhPaginationContent>
    </JhPagination>
  );
};

export default JhPaginationWrapper;
